import type { PeDomainOverlayYear } from '../../types';

export interface FlashlightPoint {
  window: string;
  value: number;
}

export interface FlashlightTrajectory {
  points: FlashlightPoint[];
  coverageText: string;
  coveragePct: number;
}

export function buildFlashlightTrajectory(
  overlay: PeDomainOverlayYear,
  domainLabel: string,
  coverageThreshold = 0.5,
): FlashlightTrajectory {
  const { students_with_any_submission_this_year, el_student_total_this_year } =
    overlay.domain_coverage;
  const total = el_student_total_this_year;

  const points: FlashlightPoint[] = [];
  for (const w of overlay.benchmark_windows) {
    if (w.average_rubric_score === null) continue;
    const windowCoverage = total > 0 ? w.n_students / total : 0;
    if (windowCoverage < coverageThreshold) continue;
    points.push({ window: w.window, value: w.average_rubric_score });
  }

  const coveragePct = total > 0 ? students_with_any_submission_this_year / total : 0;
  const coverageText = `${students_with_any_submission_this_year} of ${total} EL students completed ${domainLabel} benchmarks`;

  return { points, coverageText, coveragePct };
}
